import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import { InputLabel, FormControl, MenuItem, Select } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import AddToolbar from "../../components/common/AddToolbar";
import {
  externalpostApi,
  externalgetApi,
  externalImagepostApi,
} from "../../services/external/externalApis";

import {
  BUSINESSTYPECODE,
  EMPLOYEE_API_01,
  CHAINCODE,
  MENUTYPECODE,
  USERS_CREATE_USER_API,
  USERS_API_01,
  USERGROUP_API_01,
  LOCATION_API_01,
  FILE_API_01,
} from "../../api/ApiModel";

import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
  CON_DEFAULT_USER_PW,
  CON_PASSWORD_USER,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import { IMAGEBASEURL } from "../../api/EndPoints";
function AddUsers() {
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [data, setData] = useState(null);
  const [locationdata, setLocationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userGroups, setUserGroups] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [inputUserName, setInputUserName] = useState("");
  const [dataloc, setDataloc] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const { state } = useLocation();
  const { selectedItem } = state || {};
  const theme = useTheme();
  const styles = useStyles(theme);
  const isEdit = location.state?.actionText === "Edit";
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    LOCCODE: "",
    USERNAME: "",
    GROUPCODE: "",
    FIRSTNAME: "",
    LASTNAME: "",
    EMAIL:"",
  });
  const [imageSrc, setImageSrc] = useState(
    "https://st3.depositphotos.com/3326513/19442/v/450/depositphotos_194428038-stock-illustration-black-linear-photo-camera-logo.jpg" // Default image URL
  );
  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        COMPCODE: selectedItem.COMPCODE,
        LOCCODE: selectedItem.LOCCODE,
        USERREFCODE: String(selectedItem.USERREFCODE),
        USERNAME: selectedItem.USERNAME,
        PASSWORD: selectedItem.PASSWORD,
        EXPDATE: selectedItem.EXPDATE,
        GROUPCODE: String(selectedItem.GROUPCODE),
        STS: selectedItem.STS,
        LOCDATE: selectedItem.LOCDATE,
        FIRSTNAME: selectedItem.FIRSTNAME,
        LASTNAME: selectedItem.LASTNAME,
        EMAIL: selectedItem.EMAIL,
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    if (selectedItem && selectedItem.IMAGEPATH) {
      setImageSrc(selectedItem.IMAGEPATH);
      console.log("selectedItem.LOGO:", `${selectedItem.IMAGEPATH}`);
    }
  }, [selectedItem]);

  useEffect(() => {
    // fetchData();
    fetchUserGroups();
    fetchLocationData();
  }, []);

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERNAME, GROUPCODE, STS } = SYS_USER.USER_PARAM || {};



  const handleGroupChange = (event) => {
    setSelectedGroup(event.target.value);

    setSelectedItemDetails({
      ...selectedItemDetails,
      ["GROUPCODE"]: event.target.value,
    });
  };

  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
    setSelectedItemDetails({
      ...selectedItemDetails,
      ["LOCCODE"]: event.target.value,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setInputUserName(value);
    setSelectedItemDetails({
      ...selectedItemDetails,
      [selectedItemDetails.USERNAME]: value,
    });

    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    })); // Clear field-specific error on input
  };

    const handleInputEmailValidation = (event) => {
    const { name, value } = event.target;
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // Update userDetails state first
    handleInputChange(event);

    // Validate the email input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Email is required.", // Optional: check for empty input
      }));
    } else if (validateEmail(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid email
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid email address.", // Set error message for invalid email
      }));
    }
  };

  const gotToPage = () => {
    navigate("/ViewUsers");
  };

  const handleClearClick = () => {
    //clear text filed function goes here
    setSelectedItemDetails({
      LOCCODE: "",
      USERNAME: "",
      GROUPCODE: "",
      FIRSTNAME: "",
      LASTNAME: "",
      IMAGEPATH: "",
      EMAIL: "",
    });
  };

  const handleConfirmClick = async () => {
    const { LOCCODE, USERNAME, GROUPCODE, FIRSTNAME, LASTNAME, EMAIL } =
      selectedItemDetails;

    const requiredFields = [
      { name: "USERNAME", value: USERNAME, label: "Username" },
      { name: "GROUPCODE", value: GROUPCODE, label: "User Group" },
      { name: "LOCCODE", value: LOCCODE, label: "Default Location" },
      { name: "FIRSTNAME", value: FIRSTNAME, label: "First Name" },
      { name: "LASTNAME", value: LASTNAME, label: "Last Name" },
      { name: "EMAIL", value: EMAIL, label: "Email" },
    ];

    // Required field validation
    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError);
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      setSnackbarMessage(`Required fields.`);
      setOpenErrorSnackbar(true);
      return;
    }

    if (dataloc) {
      const isDuplicate = dataloc.some((item) => {
        if (
          item.USERNAME != selectedItemDetails.USERNAME &&
          item.USERNAME === USERNAME
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setSnackbarMessage("User name already exists."); // Show snackbar if duplicate found
        setOpenErrorSnackbar(true);
        return;
      }
    }

       const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!validateEmail(EMAIL)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        EMAIL: "Please enter a valid email address.",
      }));
      setSnackbarMessage("Please enter a valid email address.");
      setOpenErrorSnackbar(true);
      return; // Stop further execution if the email is invalid
    }
    const today = new Date();

    // Calculate today's date for LOCDATE
    const locdate = today.toISOString().split("T")[0]; // Format: YYYY-MM-DD

    // Calculate today's date plus six months for EXPDATE
    const expdate = new Date(today.setMonth(today.getMonth() + 6))
      .toISOString()
      .split("T")[0];

    const staticValues = {
      COMPCODE: COMPCODE,
      USERREFCODE: isEdit ? selectedItemDetails.USERREFCODE : "0",
      PASSWORD: CON_PASSWORD_USER,
      EXPDATE: expdate,
      STS: CON_STATUS_ACTIVE,
      LOCDATE: locdate,
      IMAGEPATH: filePath,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      const jsonString = JSON.stringify(payload);
      console.log("Payload for API call:", jsonString);
      const responseData = await externalpostApi(
        USERS_CREATE_USER_API,
        payload
      );
      console.log("Success:EEEEEEEEEEEEE", responseData);
      setSelectedItemDetails({
        LOCCODE: "",
        USERNAME: "",
        GROUPCODE: "",
        FIRSTNAME: "",
        LASTNAME: "",
        IMAGEPATH: "",
        EMAIL: "",
      });

      setSnackbarMessage("User added successfully!");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    }
    setTimeout(() => {
      navigate("/ViewUsers");
    }, 2000);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  //API Calls

  // Fetch user groups from API
  const fetchUserGroups = async () => {
    setLoading(true);
    try {
      const params = {
        COMPCODE: COMPCODE,

        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(USERGROUP_API_01, "GET", params);
      setUserGroups(response); // Assuming response is an array of user groups
      console.log("response", response);
    } catch (error) {
      setError("Failed to fetch user groups.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch locations from API
  const fetchLocationData = async () => {
    setLoading(true);
    try {
      const params = {
        COMPCODE: COMPCODE,
        STS: CON_STATUS_ACTIVE,
        GROUPCODE: GROUPCODE,
        USERNAME: USERNAME,
      };

      const response = await externalgetApi(LOCATION_API_01, "get", params);
      if (Array.isArray(response)) {
        setLocationData(response); // Ensure response is an array
      } else {
        setError("Invalid data format from API.");
        setLocationData([]); // Fallback to an empty array
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setError("Failed to fetch locations.");
      setLocationData([]); // Fallback to an empty array
    } finally {
      setLoading(false);
    }
  };

  const [filePath, setFilePath] = useState("");

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.error("No file selected.");
      return;
    }

    const fileType = file.type;
    if (fileType !== "image/jpeg" && fileType !== "image/png") {
      console.error("Only JPG and PNG files are allowed.");
      return;
    }

    // Preview the selected image
    const reader = new FileReader();
    reader.onload = (e) => setImageSrc(e.target.result);
    reader.readAsDataURL(file);

    // Prepare the FormData
    const formData = new FormData();
    formData.append("file", file);
    formData.append("COMPCODE", COMPCODE);

    try {
      // Construct the API URL
      const apiUrl = `${FILE_API_01}?COMPCODE=${encodeURIComponent(COMPCODE)}`;
      console.log("Sending request to API:", apiUrl);

      // Send the file to the server
      const response = await externalImagepostApi(apiUrl, formData);

      // Log the complete response
      console.log("API Response:", response);

      // Safely extract and format the file path
      const { filePath } = response || {};
      if (filePath) {
        const formattedPath = filePath.replace(/\\/g, "/");
        const fullPath = `${IMAGEBASEURL}${formattedPath}`;
        setFilePath(fullPath);
        setImageSrc(fullPath);
        console.log("File uploaded successfully:", fullPath);
      } else {
        console.error("File path not found in API response.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);

      if (error.response) {
        console.error("API Response Error Data:", error.response.data);
      } else {
        console.error("Network or other error:", error.message);
      }
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Users</Link>
                <Link underline="none">Add Users</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar label={{ name: isEdit ? "Edit Users" : "Add Users" }} />

        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <FormControl
              fullWidth
              size="small"
              error={Boolean(errors.GROUPCODE)}
            >
              <InputLabel id="group-select-label">
                User Group <span style={{ color: "red" }}> *</span>
              </InputLabel>
              <Select
                labelId="group-select-label"
                id="group-select"
                label="User Group"
                value={selectedItemDetails.GROUPCODE}
                onChange={handleGroupChange}
              >
                {userGroups.map((group) => (
                  <MenuItem key={group.GROUPCODE} value={group.GROUPCODE}>
                    {group.GROUPNAME}
                  </MenuItem>
                ))}
              </Select>
              {errors.GROUPCODE && (
                <p style={{ color: "red", fontSize: "12px" }}>
                  {errors.GROUPCODE}
                </p>
              )}
            </FormControl>
          </Grid>
  <Grid item lg={6} md={6} xs={12} sm={12}>
            <FormControl fullWidth size="small" error={Boolean(errors.LOCCODE)}>
              <InputLabel id="location-select-label">
                Default Location <span style={{ color: "red" }}> *</span>
              </InputLabel>
              <Select
                labelId="location-select-label"
                label="Default Location"
                id="location-select"
                value={selectedItemDetails.LOCCODE}
                onChange={handleLocationChange}
                error={Boolean(errors.USERNAME)}
                helperText={errors.USERNAME}
              >
                {locationdata.length > 0 ? (
                  locationdata.map((location) => (
                    <MenuItem key={location.LOCCODE} value={location.LOCCODE}>
                      {location.LOCATION}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No locations available</MenuItem>
                )}
              </Select>
              {errors.LOCCODE && (
                <p style={{ color: "red", fontSize: "12px" }}>
                  {errors.LOCCODE}
                </p>
              )}
            </FormControl>
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  User Name <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="USERNAME"
              disabled={isEdit}
              value={selectedItemDetails.USERNAME}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.USERNAME)}
              helperText={errors.USERNAME}
            />
          </Grid>
            <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                Email <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="EMAIL"
              // disabled={isEdit}
              value={selectedItemDetails.EMAIL}
              onChange={handleInputEmailValidation}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.EMAIL)}
              helperText={errors.EMAIL}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  First Name <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="FIRSTNAME"
              value={selectedItemDetails.FIRSTNAME}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.FIRSTNAME)}
              helperText={errors.FIRSTNAME}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Last Name <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtusername"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="LASTNAME"
              value={selectedItemDetails.LASTNAME}
              onChange={handleInputChange}
              // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
              error={Boolean(errors.LASTNAME)}
              helperText={errors.LASTNAME}
            />
          </Grid>
        
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px", // Space between the image and button
              padding: "20px",
            }}
          >
            {/* Image Preview */}
            <Box>
              {/* Image Display Box */}
              <Box
                sx={{
                  width: 150,
                  height: 150,
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f9f9f9",
                  flexShrink: 0,
                }}
              >
                {imageSrc ? (
                  <img
                    src={imageSrc}
                    alt="Selected"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      fontSize: 14,
                      color: "#888",
                      textAlign: "center",
                    }}
                  >
                    No Image Selected
                  </Box>
                )}
              </Box>
            </Box>

            {/* Upload Button */}
            <Button
              component="label"
              variant="contained"
              startIcon={<CloudUploadIcon />}
            >
              Upload Image
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageChange}
              />
            </Button>
          </Box>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
            id="btnclr"
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
            id="btnconfirm"
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={(props) => <Slide {...props} direction="left" />} // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? " Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}

export default AddUsers;
